jQuery.feature_import("js-pie-chart",
  () => require("./pie-chart.js"),
  mod => mod.feature_js_pie_chart
);